// extracted by mini-css-extract-plugin
module.exports = {"RecoveryWrapper":"Recovery_RecoveryWrapper__3KIBi","grid":"Recovery_grid__309Wh","imgWrap":"Recovery_imgWrap__2iGgC","divider":"Recovery_divider__1XgPc"};